import { hasPermission, hasAnyPermission } from "./permissions";

/**
 * Conditionally renders children based on the current user's permissions.
 *
 * Usage:
 *   <RequirePermission code="roles.create">
 *     <button>New Role</button>
 *   </RequirePermission>
 *
 *   <RequirePermission anyOf={["roles.read", "roles.update"]}>
 *     ...
 *   </RequirePermission>
 *
 * Provide either `code` (single) or `anyOf` (array, OR semantics).
 * If neither matches, renders `fallback` (default: nothing).
 *
 * This is a UI affordance only — the server still enforces permissions.
 */
export default function RequirePermission({ code, anyOf, fallback = null, children }) {
  const allowed = code
    ? hasPermission(code)
    : Array.isArray(anyOf)
    ? hasAnyPermission(anyOf)
    : false;

  return allowed ? children : fallback;
}